import { SubscriptionOrgListResult } from "api/interfaces/subscription.interface";
import { useMemo } from "react";
import { formatNumber } from "utils/functions";
import { isPendingUsagePlanSwitch } from "utils/SubscriptionUtil";
import StatusAlertBox from "./StatusAlertBox";

export default function ActivatedChannel({
  registeredChannel,
  activateChannel,
  channelExpire,
  autoEnroll,
}: SubscriptionOrgListResult): JSX.Element {
  const isOnUsagePlanNow: boolean = useMemo(() => {
    return (
      Boolean(autoEnroll) &&
      !isPendingUsagePlanSwitch({ autoEnroll, channelExpire })
    );
  }, [autoEnroll, channelExpire]);

  const toNeedActivatedChannel: boolean = useMemo(() => {
    return !Boolean(autoEnroll) && registeredChannel > activateChannel;
  }, [autoEnroll, registeredChannel, activateChannel]);

  return (
    <StatusAlertBox
      status={toNeedActivatedChannel ? "ERROR" : ""}
      showAlert={toNeedActivatedChannel}
      tooltip="Channel Required"
    >
      {isOnUsagePlanNow ? "-" : formatNumber(activateChannel)}
    </StatusAlertBox>
  );
}
